"use client";

import * as React from "react";
import { Check } from "lucide-react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { cn } from "lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer size-4 shrink-0 rounded-[4px] border border-[#EEEEEE] bg-white shadow-none outline-none transition-colors",
      "focus-visible:border-[#222222] focus-visible:ring-1 focus-visible:ring-[#222222]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:border-[#222222] data-[state=checked]:bg-[#222222] data-[state=checked]:text-white",
      "hover:border-[#CCCCCC]",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="size-3" strokeWidth={2.5} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
